/**
 * 用户输入与路由参数的格式校验工具。
 * 这些校验是第一道防线，避免把任意字符串拼到 URL/Link 中导致异常或 XSS。
 */

export const TX_HASH_RE = /^0x[0-9a-fA-F]{64}$/;
export const ADDRESS_RE = /^0x[0-9a-fA-F]{40}$/;
export const BLOCK_HEIGHT_RE = /^\d{1,18}$/;

export const isTxHash = (s: string): boolean => TX_HASH_RE.test(s.trim());
export const isAddress = (s: string): boolean => ADDRESS_RE.test(s.trim());
export const isBlockHeight = (s: string): boolean => BLOCK_HEIGHT_RE.test(s.trim());

export type SearchKind = 'tx' | 'address' | 'block';

/** 识别用户输入属于哪一类；不合法返回 null。 */
export const classifySearchInput = (input: string): { kind: SearchKind; value: string } | null => {
    const v = input.trim();
    if (!v) return null;
    if (isTxHash(v)) return { kind: 'tx', value: v };
    if (isAddress(v)) return { kind: 'address', value: v };
    if (isBlockHeight(v)) return { kind: 'block', value: v };
    return null;
};
